"use client";

import { useEffect, useState } from "react";
import {
  KeyboardSensor,
  PointerSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { sortableKeyboardCoordinates } from "@dnd-kit/sortable";

type UseSortableStudioThoughtsOptions = {
  isMobileDevice: boolean;
};

export default function useSortableStudioThoughts({
  isMobileDevice,
}: UseSortableStudioThoughtsOptions) {
  const [isDragging, setIsDragging] = useState(false);

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(isMobileDevice ? TouchSensor : PointerSensor, {
      activationConstraint: isMobileDevice ? { distance: 10 } : { distance: 5 },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );

  useEffect(() => {
    document.body.style.overflow = isDragging ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isDragging]);

  return {
    isDragging,
    sensors,
    setIsDragging,
  };
}
